<template>
	<div class="addressManage_item radius-8 ml-24 mr-24">
		<div class="flex-row flex-just-between">
			<div class="flex-1">
				<div class="flex-row">
					<div class="font-h4-medium mr-16 color-gy-9">
						{{ info.delivery_name }}
					</div>
					<div class="font-h4-medium mr-16 color-gy-9">
						{{ info.delivery_mobile }}
					</div>
					<div class="flex-row-align-center">
						<el-tag class="mr-4" v-if="info.delivery_id == delivery_id">当前使用</el-tag>
						<div v-if="info.is_default == 1" class="bgcolor-p-4 fz-12 yx-color-white addressManage_item_tab_dark"> 默认 </div>
					</div>
				</div>
				<div class="color-gy-8 font-h6-regular line-ellipsis-1 mt-2">{{ info.province }}{{ info.city }}{{ info.area }}{{ info.delivery_addr }}</div>
			</div>
			<div>
				<el-button v-if="isChoose" @click="handleUse" class="addressManage_item_btn" size="mini" type="text"> 使用 </el-button>
				<el-button @click="handleEdit" class="addressManage_item_btn" size="mini" type="text">编辑</el-button>
				<el-button @click="handleSetDefault" v-if="info.is_default != 1" class="addressManage_item_btn" size="mini" type="text"> 设为默认 </el-button>
				<el-button @click="handleCancelDefault" v-if="info.is_default == 1" class="addressManage_item_btn" size="mini" type="text">
					取消默认
				</el-button>
				<el-button @click="handleCopy" class="addressManage_item_btn" size="mini" type="text">复制</el-button>
				<el-button @click="handleDelte" :disabled="info.delivery_id == delivery_id" class="addressManage_item_btn" size="mini" type="text">
					删除
				</el-button>
			</div>
		</div>
		<div v-if="info.anchor_list.length" class="flex-row-align-center flex-just-between addressManage_item_anchor">
			<div class="flex-row-align-center">
				<span class="color-gy-7 font-h6-regular mr-4">关联达人</span>
				<div class="flex-row">
					<yx-avatar v-for="(item, index) in info.anchor_list" :key="index" :size="24" class="mr-4" :src="item.head"></yx-avatar>
				</div>
			</div>
			<div class="color-gy-7 font-h6-regular cursor-pointer" @click="handleShowAnchor">
				共{{ info.anchor_count }}位
				<i class="el-icon-arrow-right"></i>
			</div>
		</div>
	</div>
</template>

<script>
import { addressManageSetDefault, addressManageDelete, addressManageSetUsed } from '@/api/common';
import { copy } from '@/utils/common';
export default {
	props: {
		info: {
			type: Object,
			default: _ => ({}),
		},
		isChoose: {
			type: Boolean,
			default: false,
		},
		delivery_id: {
			type: [String, Number],
		},
	},
	components: {
		
	},
	methods: {
		handleShowAnchor() {
			this.$emit('showAnchorInfo', this.info.delivery_id);
		},
		async handleSetDefault() {
			await addressManageSetDefault({
				user_id: this.info.user_id,
				team_institution_id: this.info.team_institution_id,
				delivery_id: this.info.delivery_id,
				is_default: 1,
			});
			this.$message.success('操作成功！');
			this.$emit('refresh');
		},
		async handleCancelDefault() {
			await addressManageSetDefault({
				user_id: this.info.user_id,
				team_institution_id: this.info.team_institution_id,
				delivery_id: this.info.delivery_id,
				is_default: 0,
			});
			this.$message.success('操作成功！');
			this.$emit('refresh');
		},
		async handleDelte() {
			this.$modal({
				title: '确认删除地址？',
				content: '删除地址将无法恢复，确认删除？',
				size: 'small',
			}).then(async res => {
				if (res.key == 'confirm') {
					await addressManageDelete({
						delivery_id: this.info.delivery_id,
						team_institution_id: this.info.team_institution_id,
					});
					this.$message.success('操作成功！');
					this.$emit('refresh');
					res.done();
				} else {
					res.done();
				}
			});
		},
		async handleUse() {
			await addressManageSetUsed({
				user_id: this.info.user_id,
				team_institution_id: this.info.team_institution_id,
				delivery_id: this.info.delivery_id,
				is_used: 1,
			});
			this.$message.success('操作成功！');
			this.$emit('useAddress', this.info);
		},
		handleEdit() {
			this.$emit('editAddress', this.info);
		},
		handleCopy() {
			const text = `收件人：${this.info.delivery_name}\n收件电话：${this.info.delivery_mobile}\n收件地址：${this.info.province}${this.info.city}${this.info.area}${this.info.delivery_addr}`;
			copy(text);
			this.$message.success('复制成功');
		},
	},
};
</script>

<style lang="less" scoped>
.addressManage_item {
	background: #fff;
	padding: 20px;
}
.addressManage_item_tab_plain {
	border: 1px solid #e2dcff;
	height: 20px;
	border-radius: 3px;
	padding: 0 3px;
	box-sizing: border-box;
}
.addressManage_item_tab_dark {
	height: 19px;
	border-radius: 3px;
	padding: 0 3px;
	line-height: 19px;
}
.addressManage_item_btn + .addressManage_item_btn {
	position: relative;
	margin-left: 17px;
	&::after {
		content: '';
		position: absolute;
		width: 1px;
		height: 8px;
		background: #f0f1f5;
		top: 50%;
		left: -9px;
		margin-top: -4px;
	}
}
.addressManage_item_avatar {
	width: 24px;
	height: 24px;
	border-radius: 100%;
	overflow: hidden;
	margin-left: 4px;
}
.addressManage_item_anchor {
	padding-top: 16px;
	border-top: 1px solid @color-gy3;
	margin-top: 16px;
}
</style>
